import { FC } from "react";
import { InfoIcon } from "lucide-react-native";

import { DocumentGroupEnumType } from "@libs/api/patients";
import { VnBadge } from "@/components/VnBadge/VnBadge";
import { VnBox } from "@/components/VnBox";
import { VnIcon } from "@/components/VnIcon";
import { VnText } from "@/components/VnText/VnText";
import {
  VnTooltip,
  VnTooltipContent,
  VnTooltipTrigger,
} from "@/components/VnTooltip";
import {
  DocumentTypeOptionType,
  getDocumentTypeDescriptionI18nKey,
} from "@/domain/uploadedDocuments";

type DocumentTypeHintsPropsType = {
  documentGroup: DocumentGroupEnumType;
  documentTypeOptions: DocumentTypeOptionType[];
};

// Lists the document types accepted for a section, each with a tooltip
// describing what the document must show.
export const DocumentTypeHints: FC<DocumentTypeHintsPropsType> = ({
  documentGroup,
  documentTypeOptions,
}) => (
  <VnBox className="bg-secondary border-border gap-3 rounded-md border p-4">
    <VnText
      i18nKey="native:applicantDocuments.uploadOne"
      variant="lg"
      className="text-muted-foreground text-center"
    />
    <VnBox className="flex-row flex-wrap items-center justify-center gap-2">
      {documentTypeOptions.map(documentTypeOption => (
        <VnTooltip key={documentTypeOption.value}>
          <VnTooltipTrigger>
            <VnBadge
              variant="secondary"
              className="bg-sidebar-border gap-2 rounded-full">
              <VnText variant="mdMedium" i18nKey={documentTypeOption.i18nKey} />
              <VnIcon as={InfoIcon} />
            </VnBadge>
          </VnTooltipTrigger>
          <VnTooltipContent
            i18nKey={getDocumentTypeDescriptionI18nKey({
              documentGroup,
              documentType: documentTypeOption.value,
            })}
          />
        </VnTooltip>
      ))}
    </VnBox>
    <VnText
      i18nKey="native:applicantDocuments.supportedFiles"
      className="text-muted-foreground text-center"
    />
  </VnBox>
);
